/* Shikha Cake Decor - keeps cart quantities at the Yuko product minimum and shows a note. Rules are read live from Yuko. */
(function () {
  'use strict';
  var variantToProduct = {};
  var timer = null;

  function int(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }

  function buildRules() {
    var b = window.YukoOrderLimitBootstrap;
    if (!b) return null;
    var out = { byVariant: {}, byProduct: {}, all: null, allExclude: {}, byCollection: {} };
    (b.rawProductLimits || []).forEach(function (l) {
      if (String(l.status).toUpperCase() !== 'ACTIVE') return;
      var c = l.config || {}, cd = c.condition || {};
      var r = { min: int(cd.min), max: int(cd.max), step: cd.isMultiple ? Math.max(1, int(cd.multiple)) : 1 };
      if (!r.min && !r.max && r.step === 1) return;
      if (c.selectedProductType && c.selectedProductType !== 'specific') {
        out.all = r;
        (c.excludeProducts || []).forEach(function (p) { out.allExclude[String(p.id)] = true; });
        return;
      }
      (c.triggerProducts || []).forEach(function (p) {
        if (!cd.applyAllVariant && p.variantId && p.variantId.length) {
          p.variantId.forEach(function (v) { out.byVariant[String(v)] = r; });
        } else {
          out.byProduct[String(p.id)] = r;
        }
      });
    });
    (b.rawCollectionLimits || []).forEach(function (l) {
      if (String(l.status).toUpperCase() !== 'ACTIVE') return;
      var c = l.config || {}, cd = c.condition || {};
      if (cd.quantityCalculationMethod && cd.quantityCalculationMethod !== 'individual') return;
      var r = { min: int(cd.minQty), max: int(cd.maxQty), step: cd.isMultiple ? Math.max(1, int(cd.multiple)) : 1 };
      if (!r.min && !r.max && r.step === 1) return;
      (c.triggerCollections || []).forEach(function (col) { out.byCollection[String(col.id)] = r; });
    });
    return out;
  }

  function collectionsMap() {
    var b = window.YukoOrderLimitBootstrap || {};
    var map = b.productCollectionsMap;
    if (!map || !Object.keys(map).length) {
      var el = document.getElementById('yuko-product-collections-map');
      try { map = el ? JSON.parse(el.textContent || '{}') : {}; } catch (e) { map = {}; }
    }
    return map || {};
  }

  function ruleFor(variantId, rules) {
    var v = String(variantId), p = variantToProduct[v];
    if (rules.byVariant[v]) return rules.byVariant[v];
    if (p && rules.byProduct[p]) return rules.byProduct[p];
    if (p) {
      var cols = collectionsMap()[p] || [];
      for (var i = 0; i < cols.length; i++) {
        if (rules.byCollection[String(cols[i])]) return rules.byCollection[String(cols[i])];
      }
    }
    if (p && rules.all && !rules.allExclude[p]) return rules.all;
    return null;
  }

  function noteFor(input) {
    var host = input.closest('quantity-input') || input.parentElement;
    var holder = host.parentElement;
    var note = holder.querySelector(':scope > .scd-min-note');
    if (!note) {
      note = document.createElement('div');
      note.className = 'scd-min-note';
      holder.appendChild(note);
    }
    return note;
  }

  function apply() {
    var rules = buildRules();
    if (!rules) return;
    var inputs = document.querySelectorAll('input.quantity__input[data-quantity-variant-id]');
    var missing = false;
    inputs.forEach(function (input) {
      var vid = input.getAttribute('data-quantity-variant-id');
      if (!variantToProduct[vid]) missing = true;
      var r = ruleFor(vid, rules);
      if (!r) return;
      if (r.min) { input.min = r.min; input.setAttribute('data-min', r.min); }
      if (r.max) input.max = r.max;
      if (r.step > 1) input.step = r.step;
      input.setAttribute('data-scd-min', r.min || 0);
      var qty = int(input.value), note = noteFor(input);
      if (r.min && qty > 0 && qty < r.min) {
        note.className = 'scd-min-note scd-min-note--error';
        note.textContent = 'Minimum ' + r.min + ' pcs required for this item. Please increase the quantity to checkout.';
      } else if (r.min) {
        note.className = 'scd-min-note';
        note.textContent = 'Minimum order: ' + r.min + ' pcs';
      }
      var minus = (input.closest('quantity-input') || input.parentElement).querySelector('button[name="minus"]');
      if (minus && r.min) {
        var atMin = qty <= r.min;
        minus.classList.toggle('scd-at-min', atMin);
        minus.setAttribute('aria-disabled', atMin ? 'true' : 'false');
      }
    });
    if (missing) loadCart();
  }

  function loadCart() {
    if (loadCart.busy) return;
    loadCart.busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        (cart.items || []).forEach(function (it) { variantToProduct[String(it.variant_id)] = String(it.product_id); });
        loadCart.busy = false;
        apply();
      })
      .catch(function () { loadCart.busy = false; });
  }

  function flash(input) {
    var note = noteFor(input);
    note.classList.add('scd-min-note--flash');
    setTimeout(function () { note.classList.remove('scd-min-note--flash'); }, 900);
  }

  // Stop the minus button at the minimum (runs before the theme's own handler).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="minus"]');
    if (!btn) return;
    var wrap = btn.closest('quantity-input') || btn.parentElement;
    var input = wrap && wrap.querySelector('input.quantity__input[data-scd-min]');
    if (!input) return;
    var min = int(input.getAttribute('data-scd-min'));
    var step = int(input.step) || 1;
    if (min && int(input.value) - step < min) {
      e.preventDefault();
      e.stopImmediatePropagation();
      flash(input);
    }
  }, true);

  // Typed quantities below the minimum are raised back to the minimum (0 still removes the item).
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('input.quantity__input[data-scd-min]')) return;
    var min = int(input.getAttribute('data-scd-min')), q = int(input.value);
    if (min && q > 0 && q < min) { input.value = min; flash(input); }
  }, true);

  function schedule() { clearTimeout(timer); timer = setTimeout(apply, 150); }

  function start() {
    loadCart();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.nodeType === 1 && t.classList && t.classList.contains('scd-min-note')) continue;
        schedule();
        return;
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
